/**
 * Map Supabase/GoTrue auth error messages (English) to Portuguese UI copy.
 * Falls back to the original message for anything unmapped.
 */
const MAP: Array<[RegExp, string]> = [
  [/invalid login credentials/i, 'Email ou palavra-passe incorretos.'],
  [/email not confirmed/i, 'Confirme o seu email antes de entrar. Verifique a sua caixa de entrada.'],
  [/user already registered|already been registered/i, 'Já existe uma conta com este email.'],
  [/password should be at least/i, 'A palavra-passe é demasiado curta.'],
  [/for security purposes|rate limit|too many requests/i, 'Demasiadas tentativas. Aguarde um momento e tente novamente.'],
  [/unable to validate email address|invalid format/i, 'Endereço de email inválido.'],
  [/signups not allowed|signup is disabled/i, 'O registo está temporariamente indisponível.'],
  // Password recovery / change
  [
    /new password should be different|should be different from the old password/i,
    'A nova palavra-passe tem de ser diferente da anterior.',
  ],
  [
    /token has expired|otp_expired|expired or is invalid/i,
    'Esta ligação expirou ou já foi utilizada. Peça uma nova.',
  ],
  [
    /code verifier|both auth code and code verifier/i,
    'Abra a ligação no mesmo dispositivo e navegador onde fez o pedido, ou peça uma nova.',
  ],
  [/auth session missing|session_not_found/i, 'A sessão expirou. Peça uma nova ligação de recuperação.'],
  [/same password/i, 'A nova palavra-passe tem de ser diferente da anterior.'],
];

export function translateAuthError(message: string): string {
  for (const [re, pt] of MAP) {
    if (re.test(message)) return pt;
  }
  return message;
}
